module.exports = __webpack_public_path__ + "static/media/user2x.abc82bd9.jpg";